import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { abmActions } from '../../../redux/actions/abm.actions';
import { useParams } from 'react-router';
import Add from './Add';
import Edit from './Edit';
import List from './List';
import Details from './Details';
import Timeline from './Timeline';
import { Card } from '@material-ui/core';
import useStyles from './Style';
import { UnityTest } from '../../helpers/UnityTest';
import { FlowControl } from '../../helpers';

const actions = {
  Edit: (params) => <Edit {...params} />,
  Add: (params) => <Add {...params}  />,
  Details: (params) => <Details {...params} />,  
  Timeline: (params) => <Timeline {...params} />,
  default: (params) => <List {...params} />,
}

const GetAction = ({action, ...props}) => {

  const Component = actions[action] ? actions[action] : actions.default;

  return <Component {...props} />
}

const _Abm = (props) => {
  const { controller, schema, getSchema, config } = props;
  const classes = useStyles();
  let { action = "List", id = "0" } = useParams();
  const [state, setState] = useState({loaded: false, actionFn: () => {}})

  useEffect(()=>{
    if (!schema) 
      getSchema();
  }, [schema])

  useEffect(()=>{
    setState({...state, loaded: true});
  },[controller, action, id])

  return (
    <>
      {state.loaded && schema &&
      
        <Card className={classes.card}>
          <GetAction action={action} {...props} config={{...config, ...schema, columns: config.columnsAsync(schema)}} />
        </Card>    
      }
    </>
  );

}

const mapStateToProps = (controller, action) => (state) => {
  return {
    controller,
    auth: state.auth,
    config: state.config.controllers.filter(x => x.name === controller && x.action === action).pop(),
    snack: state.config.snack,
    ...state[controller],
  };
}

const mapDispatchToProps = (controller) => ({
  ...abmActions(controller)
});

/**
 * 
 * @param {*} controller string
 * @returns componente conectado a redux
 */
export const Abm = ({controller, action}) => connect(mapStateToProps(controller, action), mapDispatchToProps(controller, action))(_Abm);
